import React from 'react';
import CyberAssociationSenior2024  from 'views/CyberAssociationSenior2024';
const ClassAssembly11CPage = () => {
    return <CyberAssociationSenior2024 />;
  };
  
  export default ClassAssembly11CPage;

 